<template lang="pug">
  div.equidistant.search
    e-toolbar(
      :items="items"
      :hideRemoveButton="true"
      :showTotal="true"
      :showViewPanel="false"
      :showActionsPanel="false"
      :hideImportBtn="true"
      @deleteItems="deleteItems"
    )
    e-table(
      :items="items"
      :showDeleteButton="false"
      :showCheckbox="false"
      :defaultColumnWidth="150"
    )
      template(v-slot:actionButtons="props").actions
        button.row-edit(
          @click.stop.prevent="editItem(props.row)"
        )

    router-view
</template>

<script>
import tableMixin from '@/components/table/table-mixin'
import { equidistant } from '@/api/api-endpoints'

const TYPES_ROUTE_MAP = {
  garbage_source: {
    organization: 'garbage.organizations.update',
    def: 'garbage.defenses.update',
    med: 'garbage.medics.update',
    uk: 'garbage.managers.update',
    ind: 'garbage.individualAreas.update',
    country: 'garbage.gardens.update',
    gsk: '',
    set: 'garbage.settlements.update',
    apartmentBuildings: 'garbage.apartmentBuildings.update',
    animalHusbandry: 'garbage.animalHusbandry.update',
    recreationPurpose: 'garbage.recreationPurpose.update',
    agriculturalPurpose: 'garbage.agriculturalPurpose.update',
    specialKgo: 'msn.specialKgoCollections.update',
    dep: 'garbage.deposits.update',
    fac: 'garbage.factories.update',
    dor: 'garbage.factories.update',
    pup: 'garbage.public_place.update',
    educational: 'garbage.educational.update',
    'health-resort': 'garbage.health-resort.update',
  },
  msn: {
    container: 'msn.withContainers.update',
    noContainer: 'msn.withoutContainers.update',
    separate: 'msn.separateCollections.update',
    recyclables: 'msn.separateCollections.update',
    mercurial: 'msn.mercurialCollections.update',
    mercury: '',
    wasteCollection: 'msn.wasteCollections.update',
    planned: '',
    mercurialtemp: 'msn.mercurialTempCollections.update',
  },
  unauth_heap: {
    heap: 'unauthorized.heaps.update',
  },
  unauth_oro: {
    unauth: 'unauthorized.wpf.update',
  },
  tko_object: {
    _all: 'registry.objects.update',
  },
  tko_operator: {
    _all: 'registry.regionalOperators.update',
  },
}

export default {
  name: 'Object',
  mixins: [tableMixin],
  methods: {
    getEndpoint(route) {
      return equidistant.search(route)
    },
    editItem(row) {
      const subTypes = TYPES_ROUTE_MAP[row.type]
      let routeName = ''
      if (subTypes) {
        routeName = subTypes[row.sub_type] || subTypes['_all']
      }
      if (!routeName) {
        throw new Error('Подтип объекта не определен: ' + row.sub_type)
      }

      this.$router.push({
        name: routeName,
        params: { id: row.id },
      })
    },
  },
}
</script>
